(() => {
  'use strict';

  function findByDataValue(root, selector, dataKey, value) {
    const elements = root.querySelectorAll(selector);

    for (const element of elements) {
      if (element.dataset[dataKey] === value) return element;
    }

    return null;
  }

  function hydratePanel(panel, template) {
    if (!panel || !template) return false;
    if (panel.dataset.watchesBrandLoaded === 'true') return true;

    /*
      The deep brand markup is stored as raw text inside a non-executing
      <script> element. It therefore adds no model-thumbnail requests and no
      nested brand-panel DOM until the customer selects this brand.
    */
    panel.innerHTML = template.textContent.trim();
    panel.dataset.watchesBrandLoaded = 'true';
    template.remove();

    panel.dispatchEvent(
      new CustomEvent('watches-brand-panel:hydrated', {
        bubbles: true,
        detail: {
          panel
        }
      })
    );

    return true;
  }

  window.hydrateWatchesBrandPanel = function(megaWrapper, brandHandle) {
    if (!megaWrapper || !brandHandle) return false;

    const panel = findByDataValue(
      megaWrapper,
      '[data-watches-brand-panel]',
      'watchesBrandPanel',
      brandHandle
    );

    if (!panel) return false;
    if (panel.dataset.watchesBrandLoaded === 'true') return true;

    const template = findByDataValue(
      megaWrapper,
      'script[data-watches-brand-template]',
      'watchesBrandTemplate',
      brandHandle
    );

    return hydratePanel(panel, template);
  };

  function hydrateMobileBrand(trigger) {
    if (!(trigger instanceof Element)) return;

    const details = trigger.closest(
      'details[data-watches-mobile-brand-details]'
    );

    if (!details) return;

    const brandHandle =
      trigger.dataset.watchesMobileBrandTrigger ||
      details.dataset.watchesMobileBrandDetails;

    if (!brandHandle) return;

    const panel = findByDataValue(
      details,
      '[data-watches-mobile-brand-panel]',
      'watchesMobileBrandPanel',
      brandHandle
    );

    if (!panel) return;
    if (panel.dataset.watchesBrandLoaded === 'true') return;

    const template = findByDataValue(
      details,
      'script[data-watches-mobile-brand-template]',
      'watchesMobileBrandTemplate',
      brandHandle
    );

    hydratePanel(panel, template);
  }

  function getMobileBrandTrigger(event) {
    if (!(event.target instanceof Element)) return null;

    return event.target.closest(
      '[data-watches-mobile-brand-trigger]'
    );
  }

  /*
    Capture phase is intentional. The theme's MenuDrawer click handler runs
    during bubbling and starts the submenu transition after 100 ms. Hydrating
    here means the selected brand's links are already present before that
    existing transition begins.
  */
  document.addEventListener(
    'click',
    event => {
      const trigger = getMobileBrandTrigger(event);
      if (trigger) hydrateMobileBrand(trigger);
    },
    true
  );

  /*
    Pointer and keyboard intent prepare the selected brand even earlier while
    preserving the same click/tap behavior.
  */
  document.addEventListener(
    'pointerover',
    event => {
      const trigger = getMobileBrandTrigger(event);
      if (trigger) hydrateMobileBrand(trigger);
    },
    true
  );

  document.addEventListener(
    'focusin',
    event => {
      const trigger = getMobileBrandTrigger(event);
      if (trigger) hydrateMobileBrand(trigger);
    },
    true
  );
})();
